var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('button',{staticClass:"button is-primary",attrs:{"primary":""},on:{"click":function($event){$event.preventDefault();return _vm.goTo()}}},[_vm._v("Create a new Admin user")]),_c('br'),_c('admin-user-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }